import commonRequest from '@/utils/commonRequest';

const PATH = '/industry';

export const getIndustryList = () => commonRequest({
  url: PATH,
  method: 'get',
});
